import config from "../config.js";
import RequestManager from "./request.js";

export default class Signature {
    static async getSignature(ADELI) {
        try {
            ADELI = "0" + ADELI.slice(0, -1);
            const response = await RequestManager.get(`${config.urlBackEnd}Signature/GetSignature?ADELI=${ADELI}`);
            return response;
        } catch (error) {
            console.error("Erreur lors de la récupération de la signature :", error);
            return null;
        }
    }

    static async saveSignature(ADELI, signatureData) {
        try {
            ADELI = "0" + ADELI.slice(0, -1);
            const response = await RequestManager.post(`${config.urlBackEnd}Signature/SaveSignature`, {
                ADELI: ADELI,
                imageData: signatureData
            });
            return response;
        } catch (error) {
            console.error("Erreur lors de l'enregistrement de la signature :", error);
            throw error;
        }
    }
}
